import { css } from '@/styled-system/css';

export const assistChipLabelStyles = css.raw({
  color: 'text.neutral',
  hyphens: 'auto',
  textStyle: 'body-sm-bold',
});
